import { connect } from 'react-redux';
import { Switch, } from 'react-router';
var mapStateToProps = function (state) { return ({
    location: state.router.location,
}); };
export default connect(mapStateToProps)(Switch);



//////////////////
// WEBPACK FOOTER
// ./src/pages/components/utilities/router/SwitchConnected.tsx
// module id = 727
// module chunks = 0